export default "__VITE_ASSET__BCHKidUu__"